import React, { useEffect } from "react";
import queryString from "query-string";
import { isSafari } from "react-device-detect";
import { STATE_QUERY_PARAM, TOKEN_QUERY_PARAM } from "../config";

/**
 * OAuth callback landing page for Constant Contact integration.
 *
 * This page is NOT protected by PrivateRoute/Authorization because:
 * - It's a popup window that may be opened in a separate auth context
 * - Its only job is to relay OAuth params back to the calling window
 * - The opener window (already authenticated) handles the actual auth save
 *
 * We deliberately avoid making any API calls here that could trigger
 * auth-related side effects (like logout).
 */
export function ConstantContactIntegrationReturnUrl() {
  const params = queryString.parse(window.location.search);
  const code = params?.[TOKEN_QUERY_PARAM] || null;
  const state = params?.[STATE_QUERY_PARAM] || null;

  useEffect(() => {
    // Relay OAuth params back to the opener window
    if (window.opener && !window.opener.closed) {
      const targetOrigin = isSafari ? "*" : window.location.origin;
      window.opener.postMessage(
        {
          childWindow: "response",
          query: { code, state },
        },
        targetOrigin,
      );
      // TODO: We used to close the window immediately after posting the message,
      //  but Safari blocks the postMessage call if we do that.
      //  Instead, we let the opener window close this one after it receives the message.
      //  This is a bit less ideal because it leaves an extra window open until the message is received,
      //  but it's necessary for Safari compatibility.
      // window.close();
    }
  }, [code, state]);

  const getMessage = () => {
    if (code) {
      return "Authentication data has been received. You can close this window if it doesn’t close automatically.";
    }

    return "Cannot receive authentication data. Please close this window and retry.";
  };

  return (
    <div id="content">
      <div className="container-fluid content">
        <div className="auto-height full-width">
          <div className="m-t-20 text-center">{getMessage()}</div>
        </div>
      </div>
    </div>
  );
}
